import Vue from "vue"
import VueCtkDateTimePicker from "vue-ctk-date-time-picker"

Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker)
